/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Flex, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { CommonCardProps } from '../../../types';

const placeholderBackgroundColor = token('color.background.accent.gray.subtlest');

const legacyContainer = css({
	overflow: 'hidden',
	borderRadius: token('radius.large'),
	borderWidth: token('border.width'),
	borderColor: token('color.border'),
	borderStyle: 'solid',
	height: '100%',
});

const styles = cssMap({
	content: {
		height: '100%',
	},
	image: {
		minWidth: '28%',
		backgroundColor: placeholderBackgroundColor,
	},
	blockText: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		flex: '1 1 0',
	},
	title: {
		width: '35px',
	},
	publishedDate: {
		width: '100%',
	},

	itemCommon: {
		height: '8px',
		backgroundColor: placeholderBackgroundColor,
	},
});

export const SmallPlaceholderCard = ({
	cardDimensions,
}: Pick<CommonCardProps, 'cardDimensions'>) => {
	const cardHeight = cardDimensions.height;

	const Content = () => (
		<Flex xcss={styles.content}>
			<Box xcss={styles.image} />

			<Stack space="space.050" xcss={styles.blockText} alignBlock="center">
				<Box xcss={cx(styles.title, styles.itemCommon)} />
				<Box xcss={cx(styles.publishedDate, styles.itemCommon)} />
			</Stack>
		</Flex>
	);

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
		<div data-testId="small-placeholder-card" style={{ height: cardHeight }} css={legacyContainer}>
			<Content />
		</div>
	);
};
